import { createRootRoute, createRoute, createRouter } from "@tanstack/react-router";
import { Raiz } from "./paginas/Raiz";
import { Inicio } from "./paginas/Inicio";
import { Directorio } from "./paginas/Directorio";
import { Avisos } from "./paginas/Avisos";
import { Ajustes } from "./paginas/Ajustes";
import { Admin } from "./paginas/Admin";
import { Vitrina } from "./paginas/Vitrina";
import { Entrar } from "./paginas/Entrar";
import { Invitacion } from "./paginas/Invitacion";
import { Callback } from "./paginas/Callback";
import { Bienvenida } from "./paginas/Bienvenida";

const raiz = createRootRoute({ component: Raiz });
const inicio = createRoute({ getParentRoute: () => raiz, path: "/", component: Inicio });
const directorio = createRoute({ getParentRoute: () => raiz, path: "/directorio", component: Directorio });
const avisos = createRoute({ getParentRoute: () => raiz, path: "/avisos", component: Avisos });
const ajustes = createRoute({ getParentRoute: () => raiz, path: "/ajustes", component: Ajustes });
const admin = createRoute({ getParentRoute: () => raiz, path: "/admin", component: Admin });
const vitrina = createRoute({ getParentRoute: () => raiz, path: "/ui", component: Vitrina });
const entrar = createRoute({ getParentRoute: () => raiz, path: "/entrar", component: Entrar });
const invitacion = createRoute({ getParentRoute: () => raiz, path: "/entrar/invitacion", component: Invitacion });
// Las plantillas de correo de Supabase apuntan a /auth/confirmar; /entrar/callback queda como alias (Google, ligas viejas).
const confirmar = createRoute({ getParentRoute: () => raiz, path: "/auth/confirmar", component: Callback });
const callback = createRoute({ getParentRoute: () => raiz, path: "/entrar/callback", component: Callback });
const bienvenida = createRoute({ getParentRoute: () => raiz, path: "/bienvenida", component: Bienvenida });

export const router = createRouter({
  routeTree: raiz.addChildren([
    inicio,
    directorio,
    avisos,
    ajustes,
    admin,
    vitrina,
    entrar,
    invitacion,
    confirmar,
    callback,
    bienvenida,
  ]),
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
